import * as React from 'react';
import { Field, formValueSelector } from 'redux-form';
import { get } from 'lodash';
import { branch, renderNothing, compose, withHandlers, defaultProps, withStateHandlers, lifecycle } from 'recompose';
import ltt from 'list-to-tree-lite';
import { Grid } from 'react-flexbox-grid';
import { connect } from 'react-redux';
import { Card } from 'material-ui';

import Button from '@inqool/uas-web-core/es/components/controls/Button';
import remote from '@inqool/uas-web-core/es/components/controls/remote';

import * as T from '@components/form/RemoteAutoCompleteTree/_remoteAutoCompleteTreeTypes';
import AutoComplete, { AutoCompleteField } from '../AutoComplete/AutoComplete';
import { Tree } from '@components/form/Tree/Tree';
import { ModalButton } from '@components/modalButton/ModalButton';

const TreeModal = ({ closeItem, treeData, handleValue, handleUnpackedItems, selectedValue, unpackedItems }) => {
  return (
    <div style={{ margin: '15px' }}>
      <Grid fluid={true}>
        <Card style={{ height: '60vh', overflow: 'auto' }}>
          <Tree
            treeData={treeData}
            handleValue={handleValue}
            handleUnpackedItems={handleUnpackedItems}
            selectedValue={selectedValue}
            unpackedItems={unpackedItems}
          />
        </Card>
      </Grid>
      <Button label={'Zavřít'} onClick={closeItem} style={{ marginTop: '15px' }} />
    </div>
  );
};

const enhance = compose<T.InnerProps, T.OutterProps>(
  defaultProps({
    itemLabel: 'label',
    formName: 'not-defined',
    input: { name: 'not-defined' },
    url: 'not-defined',
    params: {
      pageSize: 999,
      filter: [
        {
          field: 'active',
          operation: 'EQ',
          value: true
        }
      ],
      sorting: [
        {
          sort: 'order',
          order: 'ASC'
        },
        {
          sort: 'name',
          order: 'ASC'
        }
      ]
    },
    loopControl: false,
    labelFunction: o => o,
    valueFunction: o => o
  }),
  connect<any>((state, { formName, input }: T.OutterProps) => ({
    initialValue: formValueSelector(formName)(state, input.name),
    controlValue: formValueSelector(formName)(state, 'id')
  })),
  remote,
  branch<any>(({ items }) => !items.length, renderNothing),
  withStateHandlers(
    {},
    {
      setState: _ => state => state
    }
  ),
  lifecycle<any, any>({
    componentDidMount() {
      const { items, itemLabel, initialValue, loopControl, controlValue, setState } = this.props;

      // Tree Data structure
      const checkedItems = loopControl ? items.filter(o => get(o, 'id') !== controlValue) : items;
      const modifiedItems = checkedItems.map(item => ({
        ...item,
        key: item.id,
        title: item[itemLabel],
        parent: get(item, 'parent.id')
      }));
      const treeData = ltt(modifiedItems);

      // Default value for tree
      const selectedValue = get(initialValue, 'id');
      let unpackedItems: Array<string> = [];
      if (selectedValue) {
        const selectedValueObject = modifiedItems.find(o => get(o, 'id') === selectedValue);
        let parent: string = get(selectedValueObject, 'parent');

        while (!!parent) {
          unpackedItems = [parent, ...unpackedItems];
          const parentObject = modifiedItems.find(o => get(o, 'id') === parent);
          parent = get(parentObject, 'parent');
        }
      }

      setState({
        modifiedItems,
        treeData,
        selectedValue,
        unpackedItems
      });
    }
  }),
  branch<any>(({ unpackedItems }) => !unpackedItems, renderNothing),
  withStateHandlers<any, any>(
    ({ selectedValue, unpackedItems }) => ({
      selectedValue,
      unpackedItems
    }),
    {
      handleValue: state => selectedValue => ({ ...state, selectedValue }),
      handleUnpackedItems: ({ unpackedItems: ui, ...rest }) => value => ({
        ...rest,
        unpackedItems: !!ui.find(i => i === value) ? ui.filter(i => i !== value) : [...ui, value]
      })
    }
  ),
  withHandlers({
    handleValue: ({ handleValue, change, input, modifiedItems, valueFunction }) => value => {
      handleValue(value);
      const item = modifiedItems.find(o => get(o, 'id') === value);
      change(input.name, value ? valueFunction(item) : null);
    }
  })
);

const RemoteAutoCompleteTreeView: React.SFC<any> = ({
  treeData,
  handleValue,
  handleUnpackedItems,
  selectedValue,
  unpackedItems,
  input,
  label,
  items,
  valueFunction,
  labelFunction,
  fullWidth,
  arrowstyle,
  disabled,
  validateValue
}) => (
  <div style={{ position: 'relative', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    <AutoCompleteField
      component={AutoComplete}
      label={label}
      name={input.name}
      items={items}
      disabled={true}
      fullWidth={fullWidth}
      valueFunction={valueFunction}
      labelFunction={labelFunction}
      arrowstyle={arrowstyle}
      validate={validateValue}
    />
    <ModalButton
      label={'Vybrat'}
      style={{ margin: 10 }}
      disabled={disabled}
      treeData={treeData}
      handleValue={handleValue}
      handleUnpackedItems={handleUnpackedItems}
      selectedValue={selectedValue}
      unpackedItems={unpackedItems}
      ModalComponent={TreeModal}
    />
  </div>
);

export default enhance(RemoteAutoCompleteTreeView);

export class RemoteAutoCompleteTreeField extends Field<T.OutterCustomProps> {}



// WEBPACK FOOTER //
// ./src/components/form/RemoteAutoCompleteTree/RemoteAutoCompleteTree.tsx